module.exports = __webpack_public_path__ + "img/anli-3.1ce7a5f5.jpg";